import { c as _c } from "react/compiler-runtime";
import { chakra } from '@chakra-ui/react';
import { RenderElementProps } from 'slate-react';
export const UnorderedListElement = props => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props.attributes || $[1] !== props.children) {
    t0 = <chakra.ul {...props.attributes}>{props.children}</chakra.ul>;
    $[0] = props.attributes;
    $[1] = props.children;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};